export const HISTORY_TYPE = {
  ALL: 0,
  STAKING: 1,
  UN_STAKE: 2,
  STAKE_REWARD: 3,
  STAKE_CLAIM_REWARD: 4,
  VESTING: 5,
  P2P_DEPOSIT: 6,
  STAKE_WITHDRAW: 7,
  P2P_WITHDRAW: 8,
  // PTO
  TOKENIZE_DEPOSIT: 9,
  TOKENIZE_WITHDRAW: 10,
  TOKENIZE_REFUND: 11,
  // Referral
  REF_CLAIM_REWARD: 12,
  // Vesting HMC
  VESTING_HMC: 13,
  // Stake NFT
  STAKE_NFT: 14,
  UN_STAKE_NFT: 15,
  STAKE_NFT_CLAIM_REWARD: 16,
  REF_CLAIM_REWARD_USDC: 17,
  // Stake token
  STAKE_TOKEN: 18,
  UN_STAKE_TOKEN: 19,
  STAKE_TOKEN_REWARD: 20,
  STAKE_TOKEN_CLAIM_REWARD: 21,
  STAKE_TOKEN_WITHDRAW: 22,
  // Vesting Ventures
  VESTING_VENTURE: 23,
}

export const HISTORY_TYPE_ARRAY = [
  {
    label: 'All',
    value: HISTORY_TYPE.ALL,
  },
  {
    label: 'Stake',
    value: HISTORY_TYPE.STAKING,
  },
  {
    label: 'UnStake',
    value: HISTORY_TYPE.UN_STAKE,
  },
  {
    label: 'Stake rewards',
    value: HISTORY_TYPE.STAKE_REWARD,
  },
  {
    label: 'Withdraw rewards',
    value: HISTORY_TYPE.STAKE_CLAIM_REWARD,
  },
  {
    label: 'Withdraw',
    value: HISTORY_TYPE.STAKE_WITHDRAW,
  },
  {
    label: 'Claim vesting',
    value: HISTORY_TYPE.VESTING,
  },
  {
    label: 'P2P Lend',
    value: HISTORY_TYPE.P2P_DEPOSIT,
  },
  {
    label: 'P2P Withdraw',
    value: HISTORY_TYPE.P2P_WITHDRAW,
  },
  {
    label: 'PTO purchased',
    value: HISTORY_TYPE.TOKENIZE_DEPOSIT,
  },
  {
    label: 'PTO claim NFT',
    value: HISTORY_TYPE.TOKENIZE_WITHDRAW,
  },
  {
    label: 'PTO refunded',
    value: HISTORY_TYPE.TOKENIZE_REFUND,
  },
  {
    label: 'Claim reward Mey affiliate',
    value: HISTORY_TYPE.REF_CLAIM_REWARD,
  },
  {
    label: 'Staking Nft',
    value: HISTORY_TYPE.STAKE_NFT,
  },
  {
    label: 'Unstake Nft',
    value: HISTORY_TYPE.UN_STAKE_NFT,
  },
  {
    label: 'Claim reward ',
    value: HISTORY_TYPE.STAKE_NFT_CLAIM_REWARD,
  },
  {
    label: 'Claim vesting HMC',
    value: HISTORY_TYPE.VESTING_HMC,
  },
  {
    label: 'Claim vesting venture',
    value: HISTORY_TYPE.VESTING_VENTURE,
  },
  {
    label: 'Claim vesting HMC',
    value: HISTORY_TYPE.VESTING_HMC,
  },
  {
    label: 'Claim vesting Venture',
    value: HISTORY_TYPE.VESTING_VENTURE,
  },
  {
    label: 'Stake Token',
    value: HISTORY_TYPE.STAKE_TOKEN,
  },
  {
    label: 'UnStake token',
    value: HISTORY_TYPE.UN_STAKE_TOKEN,
  },
  {
    label: 'Stake token rewards',
    value: HISTORY_TYPE.STAKE_TOKEN_REWARD,
  },
  {
    label: 'Withdraw rewards',
    value: HISTORY_TYPE.STAKE_TOKEN_CLAIM_REWARD,
  },
  {
    label: 'Withdraw',
    value: HISTORY_TYPE.STAKE_TOKEN_WITHDRAW,
  },
]
